import { createReducer } from "@reduxjs/toolkit";
import { resetUpdateTeacherFavoriteStudio, updateTeacherFavoriteStudio } from "./update-teacher-favorite-studio";
import type { ProcessingState } from "@redux/state/shared-types";

const initialState: ProcessingState = { processing: "idle" };

export const updateTeacherFavoriteStudioReducer = createReducer<ProcessingState>(initialState, builder => {
  builder.addCase(updateTeacherFavoriteStudio.fulfilled, state => {
    return {
      ...state,
      processing: "success",
    };
  });
  builder.addCase(updateTeacherFavoriteStudio.pending, state => {
    return {
      ...state,
      processing: "pending",
    };
  });
  builder.addCase(updateTeacherFavoriteStudio.rejected, state => {
    return {
      ...state,
      processing: "failed",
    };
  });
  builder.addCase(resetUpdateTeacherFavoriteStudio, () => {
    return initialState;
  });
});
